import styled from 'styled-components';

export const StyledPaginationWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 16px;
  justify-content: flex-end;
`;
